import Head from "next/head";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Header from "../components/Header";
import Banner from "../components/_quemSomos/Banner";
import styles from "../styles/pages/quem-somos.module.scss";
import Cta from "../components/Cta";
import Media from "../components/Media";
import FloatLinks from "../components/FloatLinks";
import { GetStaticProps } from "next/types";

export default function QuemSomos() {
  useEffect(() => {
    AOS.init({
      disable: "mobile",
      duration: 700,
      easing: "ease-out-cubic",
      once: true,
    });
  }, []);

  return (
    <>
      <Head>
        <title>Saiba quem somos e qual o nosso objetivo | Kenzie Academy</title>
        <meta
          name="description"
          content="Nascida nos Estados Unidos em 2017, a Kenzie Academy chegou ao Brasil para oferecer a melhor formação em programação. Confira nossa história!"
        />
        <meta
          name="twitter:title"
          content="Saiba quem somos e qual o nosso objetivo | Kenzie Academy"
        />
        <meta
          name="twitter:description"
          content="Nascida nos Estados Unidos em 2017, a Kenzie Academy chegou ao Brasil para oferecer a melhor formação em programação. Confira nossa história!"
        />
        <meta
          property="og:title"
          content="Saiba quem somos e qual o nosso objetivo | Kenzie Academy"
        />
        <link rel="canonical" href="https://kenzie.com.br/quem-somos" />
      </Head>

      <Header />

      <main>
        <section className={styles.wrapper}>
          <div className={styles.background}>
            <div className={styles.container}>
              <div className={styles.contentContainer} data-aos="fade-right">
                <h1 className={styles.title}>
                  Nosso foco é transformar vidas!
                </h1>
                <p>
                  Através da educação e da programação, fazemos diferença real
                  na realidade de milhares de pessoas.
                </p>
                <Cta
                  url="https://inscricao.kenzie.com.br"
                  maxWidthDesktop="28rem"
                  color="white"
                  passParams
                  text="Entrar na Lista de Espera"
                  centralized={false}
                  background
                />
              </div>
            </div>
          </div>
        </section>
        <Banner />
        <Media />
      </main>
      <FloatLinks />
    </>
  );
}

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {},
    revalidate: 60 * 60 * 24,
  };
};
